import React, { useState } from "react";
import "../productMaster/productMaster.scss";
import product from "../../assets/images/product12.png";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import UploadProductImageModal from "../../components/productMaster/UploadProductImageModal";
import UploadSecondaryImageModal from "../../components/productMaster/UploadSecondaryImageModal ";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];

const AddNewProduct = () => {
  const [distributertag, setDistributerTag] = useState([]);
  const handleChange = (selected) => {
    setDistributerTag(selected);
  };
  return (
    <div className="container-fluid add-new-product-sec">
      <section className="add-product-details-sec mt-3">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-header">
                <h6>Product Details</h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>
                            Product Name <span className="mandatory">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Product Name"
                          ></input>
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>
                            Select Main Category{" "}
                            <span className="mandatory">*</span>
                          </label>
                          <ReactSelect
                            className="basic-multi-select"
                            styles={style}
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>Select Sub Category</label>
                          <ReactSelect
                            className="basic-multi-select"
                            styles={style}
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>Product Keywords </label>
                          <ReactSelect
                            className="basic-multi-select"
                            styles={style}
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>Description </label>
                          <textarea
                            className="form-control"
                            placeholder="Enter Product Description"
                            rows="5"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="row mob-m-t-20 product-image-add">
                      <div class="col-md-12">
                        <label>
                          Product Primary Image <span class="mandatory">*</span>
                        </label>
                        <div>
                          <label
                            class="label2"
                            data-toggle="modal"
                            data-target="#uploadProductImageModal"
                          >
                            <div id="start">
                              <span>
                                <i class="fas fa-camera"></i>
                              </span>
                              <div class="product-capt-color mt-2">
                                Add Product Image{" "}
                              </div>
                            </div>
                          </label>
                        </div>
                        {/* <!-- after image add starts--> */}

                        <div class="row added-product-image-area">
                          <div class="col-md-12 col-lg-6 col-xs-12">
                            <div class="added-product-image">
                              <img src={product} />
                            </div>
                          </div>
                          <div class="col-md-12 col-lg-6 col-xs-12">
                            <div>
                              <div class="icons">
                                <i
                                  class="far fa-edit"
                                  data-toggle="modal"
                                  data-target="#uploadProductImageModal"
                                ></i>
                                <i class="far fa-trash-alt"></i>
                              </div>
                            </div>
                            <div>
                              <div>
                                <p>Title</p>
                                <h6>
                                  1.5 hour Rated Static Curtain fire damper
                                </h6>
                              </div>
                              <div>
                                <p>Model Number</p>
                                <h6>Model - 119</h6>
                              </div>

                              <p>File URL:</p>
                              <h6>
                                <a
                                  href="https://jmc.com/wp-content/uploads/2021/03/4190-8910-in-Simplex.jpg"
                                  target="_blank"
                                >
                                  https://jmc.com/wp-content/uploads/2021/03/4190-8910-in-Simplex.jpg
                                </a>
                              </h6>
                            </div>
                          </div>
                        </div>
                        {/* //   <!-- after image add end--> */}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="product-img-gallery">
                          <p>Product Secondary Images</p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="float-right">
                          <button
                            type="button"
                            data-toggle="modal"
                            data-target="#uploadSecondaryImageModal"
                          >
                            Add images
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="row grey-box2">
                      <div class="col-md-3 mob-p-b-10">
                        <div class="small-grey-box1"></div>
                      </div>
                      <div class="col-md-3 mob-p-b-10">
                        <div class="small-grey-box1"></div>
                      </div>
                      <div class="col-md-3 mob-p-b-10">
                        <div class="small-grey-box1"></div>
                      </div>
                      <div class="col-md-3 mob-p-b-10">
                        <div class="small-grey-box1"></div>
                      </div>
                    </div>

                    <div class="row grey-box2">
                      <div class="col-md-3 mob-p-b-10">
                        <div class="gallery-images ml-2">
                          <img src="image['url']" />
                          <div class="overlay">
                            <div class="text">
                              <i class="far fa-trash-alt"></i>
                              <i
                                class="far fa-eye ml-2"
                                data-toggle="modal"
                                data-target="#actualProductImageViewModal"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-header">
                <h6>Product Attributes</h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Fire Rating</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Application</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Material</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Frame Type</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Blade Style</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Orientation</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div>
                      <label>Style</label>
                      <ReactSelect
                        className="basic-multi-select"
                        styles={style}
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link active"
                      id="general-configuration-tab"
                      data-toggle="tab"
                      href="#generalConfiguration"
                      role="tab"
                      aria-controls="general-configuration"
                      aria-selected="true"
                    >
                      General Configuration
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="sleeve-tab"
                      data-toggle="tab"
                      href="#sleeve"
                      role="tab"
                      aria-controls="sleeve"
                      aria-selected="false"
                    >
                      Sleeve
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="seal-tab"
                      data-toggle="tab"
                      href="#seal"
                      role="tab"
                      aria-controls="seal"
                      aria-selected="false"
                    >
                      Seal
                    </a>
                  </li>

                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="accessories-tab"
                      data-toggle="tab"
                      href="#accessories"
                      role="tab"
                      aria-controls="accessories"
                      aria-selected="false"
                    >
                      Accessories
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="seal-tab"
                      data-toggle="tab"
                      href="#seal"
                      role="tab"
                      aria-controls="seal"
                      aria-selected="false"
                    >
                      Seal
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="mounting-tab"
                      data-toggle="tab"
                      href="#mounting"
                      role="tab"
                      aria-controls="mounting"
                      aria-selected="false"
                    >
                      Mounting
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="transition-tab"
                      data-toggle="tab"
                      href="#transition"
                      role="tab"
                      aria-controls="transition"
                      aria-selected="false"
                    >
                      Transition
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="actuator-tab"
                      data-toggle="tab"
                      href="#actuator"
                      role="tab"
                      aria-controls="actuator"
                      aria-selected="false"
                    >
                      Actuator
                    </a>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="generalConfiguration"
                    role="tabpanel"
                    aria-labelledby="general-configuration-tab"
                  >
                    <div className="row mt-3">
                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                        <div>
                          <label>Frame Material</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Product Name"
                          ></input>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                        <div>
                          <label>Frame Size</label>
                          <ReactSelect
                            className="basic-multi-select"
                            styles={style}
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                        <div>
                          <label>Velocity Rating</label>
                          <ReactSelect
                            className="basic-multi-select"
                            styles={style}
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                        <div>
                          <label>Pressure Rating</label>
                          <ReactSelect
                            className="basic-multi-select"
                            styles={style}
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="sleeve"
                    role="tabpanel"
                    aria-labelledby="sleeve-tab"
                  >
                    ...
                  </div>
                  <div
                    class="tab-pane fade"
                    id="seal"
                    role="tabpanel"
                    aria-labelledby="seal-tab"
                  >
                    ...
                  </div>

                  <div
                    class="tab-pane fade"
                    id="accessories"
                    role="tabpanel"
                    aria-labelledby="accessories-tab"
                  >
                    ...
                  </div>
                  <div
                    class="tab-pane fade"
                    id="mounting"
                    role="tabpanel"
                    aria-labelledby="mounting-tab"
                  >
                    ...
                  </div>
                  <div
                    class="tab-pane fade"
                    id="transition"
                    role="tabpanel"
                    aria-labelledby="transition-tab"
                  >
                    ...
                  </div>
                  <div
                    class="tab-pane fade"
                    id="actuator"
                    role="tabpanel"
                    aria-labelledby="actuator-tab"
                  >
                    ...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-header">
                <h6>Product Size & weight</h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div className="d-flex">
                      <div>
                        <label>Height</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Product Name"
                        ></input>
                      </div>

                      <div className="mt-32 ml-1">
                        <ReactSelect
                          className="basic-multi-select"
                          styles={style}
                          options={colourOptions}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          onChange={handleChange}
                          allowSelectAll={true}
                          value={distributertag}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              neutral80: "#000000",
                            },
                          })}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div className="d-flex">
                      <div>
                        <label>Width</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Product Name"
                        ></input>
                      </div>

                      <div className="mt-32 ml-1">
                        <ReactSelect
                          className="basic-multi-select"
                          styles={style}
                          options={colourOptions}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          onChange={handleChange}
                          allowSelectAll={true}
                          value={distributertag}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              neutral80: "#000000",
                            },
                          })}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div className="d-flex">
                      <div>
                        <label>Length</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Product Name"
                        ></input>
                      </div>

                      <div className="mt-32 ml-1">
                        <ReactSelect
                          className="basic-multi-select"
                          styles={style}
                          options={colourOptions}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          onChange={handleChange}
                          allowSelectAll={true}
                          value={distributertag}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              neutral80: "#000000",
                            },
                          })}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-3">
                    <div className="d-flex">
                      <div>
                        <label>Weight</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Product Name"
                        ></input>
                      </div>

                      <div className="mt-32 ml-1">
                        <ReactSelect
                          className="basic-multi-select"
                          styles={style}
                          options={colourOptions}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option,
                          }}
                          onChange={handleChange}
                          allowSelectAll={true}
                          value={distributertag}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              neutral80: "#000000",
                            },
                          })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-5 mb-5">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
            <div className="cancel-save-btns d-flex justify-content-end">
              <button type="button" className="btn cancel-btn">
                Cancel
              </button>
              <button type="button" className="btn save-btn">
                Save
              </button>
            </div>
          </div>
        </div>
        {/* <!-- uploadProductImageModal start --> */}
        <UploadProductImageModal />

        {/* <!-- uploadSecondaryImageModal--> */}
        <UploadSecondaryImageModal />
      </section>
    </div>
  );
};

export default AddNewProduct;
